import { memo } from 'react';
import { Platform } from 'react-native';

import Box from '../Box/Box';
import PressableIcon from '../PressableIcon/PressableIcon';

import { BettyIgoLogoProps } from './BettyIgoLogo.types';

function BettyIgoLogo({
  onBettyPress,
  onIgoPress,
  ...props
}: BettyIgoLogoProps) {
  return (
    <Box flexDirection="row" centerContent gap="space-300" {...props}>
      <PressableIcon
        name="bettyLogo"
        height={28}
        width={63}
        onPress={onBettyPress}
      />
      <Box
        width="space-025"
        height="100%"
        borderWidth="border-width-025"
        borderColor="borderSecondary"
      />
      <PressableIcon
        name="iGOLogo"
        height={24}
        width={84}
        onPress={Platform.OS === 'web' ? onIgoPress : undefined}
      />
    </Box>
  );
}

export default memo(BettyIgoLogo);
